import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { axiosClient } from '../../../core/axios-client'

const fetchRentStatuses = createAsyncThunk(
  'fetchRentStatuses',
  async () => {
    const requests = await axiosClient.get('/companies/selected/rents/statuses')
    return requests.data
  }
)

const initialState = {
  rentStatuses: [],
}

export const slice = createSlice({
  name: 'rentStatuses',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchRentStatuses.fulfilled, (state, { payload }) => {
      state.rentStatuses = payload.data;
    })
  }
})

export {
  fetchRentStatuses,
}

export default slice.reducer;
